import React from "react";

import LoginStepOne from "img/how-to-img/login.png";
import CreateDeliveryStepTwo from "img/how-to-img/create-delivery.png";
import ProductStepThree from "img/how-to-img/product-package.png";
import LocationStepFour from "img/how-to-img/location.png";
import ProductStepFive from "img/how-to-img/product-correct.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Create a Delivery</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={LoginStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Log In to Your Account
          </h1>
          <p className="small-para">
            Go to the Tripple Air website and log in to your Customer or Company
            account. Make sure your profile is verified so you can access the
            delivery dashboard.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={CreateDeliveryStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Select 'Create Delivery'
          </h1>
          <p className="small-para">
            From your dashboard or menu, click on "Create Delivery" or "New
            Delivery Request." This will take you to a form where you can enter
            delivery details.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ProductStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Enter Package Details
          </h1>
          <p className="small-para">
            Fill in information about the item(s): type of goods, weight,
            dimensions, and value. Be sure to include any special handling
            instructions or restrictions.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={LocationStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Add Pickup & Drop-off Info
          </h1>
          <p className="small-para">
            Provide the pickup address, recipient name, and delivery address.
            You may also select preferred pickup times and delivery windows,
            depending on availability.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ProductStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Confirm & Submit Request
          </h1>
          <p className="small-para">
            Review all the entered information carefully. Once everything looks
            correct, click "Confirm" or "Submit Delivery." You'll receive a
            confirmation email and tracking ID once it's processed.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ProductStepThree}
            alt="Step Six"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 6: Confirm and Pay
          </h1>
          <p className="small-para">
            Review the payment summary and delivery charges. Once everything
            looks good, tap "Confirm Payment." You'll get a confirmation message
            and receipt within the app and via email.
          </p>
        </div>
      </div>
    </div>
  );
}
